import { render } from "./LessonCatsTopic5.vue?vue&type=template&id=1cb36a41"
import script from "./LessonCatsTopic5.vue?vue&type=script&lang=js"
export * from "./LessonCatsTopic5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__